'use client';

import React from 'react';

interface StatCardProps {
  icon: string;
  label: string;
  value: string | number;
  /** Secondary muted value e.g. "/154" */
  suffix?: string;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  iconBg?: string;
  iconColor?: string;
  linkLabel?: string;
  onLinkClick?: () => void;
}

const StatCard = React.memo(function StatCard({
  icon,
  label,
  value,
  suffix,
  change,
  changeType = 'positive',
  iconBg = 'bg-[var(--hrm-primary-light)]',
  iconColor = 'text-[var(--hrm-primary-dark)]',
  linkLabel,
  onLinkClick,
}: StatCardProps) {
  return (
    <div className="hrm-card hrm-card-hover p-5">
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${iconBg}`}>
          <i className={`${icon} text-lg ${iconColor}`} />
        </div>
        {change && (
          <span
            className={`inline-flex items-center gap-0.5 text-[10px] font-semibold px-2 py-0.5 rounded-full ${
              changeType === 'positive'
                ? 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/20 dark:text-emerald-400'
                : changeType === 'negative'
                  ? 'text-red-500 bg-red-50 dark:bg-red-900/20 dark:text-red-400'
                  : 'text-slate-500 bg-slate-100 dark:bg-slate-800'
            }`}
          >
            {changeType === 'positive' && <i className="ri-arrow-up-s-fill text-sm" />}
            {changeType === 'negative' && <i className="ri-arrow-down-s-fill text-sm" />}
            {change}
          </span>
        )}
      </div>
      <h3 className="text-xs text-slate-500 dark:text-slate-400 mb-1 font-medium">{label}</h3>
      <p className="text-xl font-bold text-slate-800 dark:text-white">
        {value}
        {suffix != null && <span className="text-slate-400 font-semibold">{suffix}</span>}
      </p>
      {linkLabel && (
        <button
          type="button"
          onClick={onLinkClick}
          className="text-xs text-slate-400 mt-2 inline-block hover:text-[var(--hrm-primary-dark)] transition-colors"
        >
          {linkLabel}
        </button>
      )}
    </div>
  );
});

export default StatCard;
